/**
 * Whether a failed write may still have landed: no response came back (a
 * network error, a timeout) or the server failed partway (a 5xx). A 4xx is
 * a refusal — nothing changed — and is said as one.
 */
export function outcomeUnknown(err) {
  const status = err?.response?.status;
  return !Number.isInteger(status) || status >= 500; // no response: no status
}

/** A server message as a sentence: ends with its own stop, or gets one. */
export function asSentence(message) {
  const text = String(message ?? "").trim();
  return /[.!?]$/.test(text) ? text : `${text}.`;
}
